<template>
  <div class="overlay">
    <div class="overlay__inner">
      <div class="panel">
        <div class="panel__header">
          <h3 class="panel__title">{{ accountUserName }} Edit Customers</h3>

          <p>Limit commissions to orders only from the specified customers.</p>

          <span class="overlay__close" @click="done">
            <i class="fal fa-times"></i
            ></span>
        </div>
        <div class="panel__content">
          <div class="form-field">
            <div class="grid-x grid-padding-x">
              <div class="cell small-4">
                <label>Customer Accounts</label>
              </div>
              <div class="cell auto">
                <div v-if="pushCustomers.length > 0">
                  <div v-for="customer in pushCustomers" :key="customer.id">
                    {{ customer.first_name }} {{ customer.last_name }}
                    <button class='button--small remove text-right'
                            @click="removeCustomer(customer.id)">x
                    </button>
                  </div>
                </div>
                <div v-else>
                  This Vendor Currently is not associated with any customers
                </div>
              </div>
            </div>
          </div>

          <div class="form-field" style="position: relative; z-index: 2; ">
            <div class="grid-x grid-padding-x">
              <div class="cell small-4">
                <label>Add Customer</label>
              </div>
              <div class="cell small-5">
                <div class="cell auto">
                  <div class="searchable-field">
                    <input id="customer-override" name="customer-override"
                           type="text"
                           placeholder="type 3 characters to search..."
                           v-on:input='searchCustomers($event.target.value)'>

                    <div class="searchable-field__data"
                         v-if="searchedCustomers.length > 0">

                      <div :id="row.id" class="searchable-field__option"
                           v-for="(row, key) in searchedCustomers" :key="key"
                           @click="addCustomer(row)">
                        {{ row.first_name }} {{ row.last_name }}
                        <span v-if="row.vendor">(vendor: {{ row.vendor }})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="panel__footer text-right">
            <button class="button--alt" @click="done">Cancel</button>
            <button @click="saveCustomers">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'
import utils from '@/mixins/utils'
import Checkbox from '@/globals/checkbox'

export default {
  components: {Checkbox},
  props: [
    'accountUserName',
    'accountCustomerList',
    'vendorId',
    'accountApproval'
  ],
  mixins: [client, utils],
  data: function () {
    return {
      customerName: '',
      searchedCustomers: [],
      pushCustomers: [],
      approval: '',
      customerIDs: [],
      id: ''
    }
  },
  methods: {
    done () {
      this.$emit('done')
    },
    addCustomer (customer) {
      let isPresent = false
      for (let i = 0; i < this.pushCustomers.length; i++) {
        if (customer.id === this.pushCustomers[i].id) {
          isPresent = true
        }
      }
      if (isPresent === false) {
        this.pushCustomers.push(customer)
      }
      this.searchedCustomers = []
    },
    saveCustomers () {
      this.customerIDs = []

      for (var i = 0; i < this.pushCustomers.length; i++) {
        this.customerIDs.push(this.pushCustomers[i].id)
      }

      this.request('post', '/vendors/' + this.vendorId + '/customers/', {
        customers: this.customerIDs
      }).then(response => {
        this.$emit('save')
      })
    },
    searchCustomers (value) {
      if (value.length >= 3 && !this.searchingCustomers) {
        this.searchingCustomers = true

        this.request('get', '/customers/', {
          search: value,
          ordering: 'first_name'
        }).then(response => {
          let items = response.results
          this.searchedCustomers = []

          for (let i = 0; i < items.length; i++) {
            this.searchedCustomers.push({
              id: items[i].id,
              first_name: items[i].first_name,
              last_name: items[i].last_name,
              vendor: items[i].vendor
            })
          }
          this.searchingCustomers = false
        })
      }
    },
    removeCustomer (customerId) {
      for (let i = 0; i < this.pushCustomers.length; i++) {
        if (this.pushCustomers[i].id === customerId) {
          this.pushCustomers.splice(i, 1)
        }
      }
    }
  },
  created () {
    this.request('get', '/vendors/' + this.vendorId + '/customers/', {
      ordering: 'first_name'
    }).then(response => {
      for (let i = 0; i < response.length; i++) {
        this.pushCustomers.push({
          id: response[i].customer_id,
          first_name: response[i].customer__first_name,
          last_name: response[i].customer__last_name
        })
      }
    })
  }

}

</script>

<style lang="scss" scoped>
@import "../styles/mixins";
@import "../styles/variables";

.remove {
  margin-left: 5px;
  margin-bottom: 5px;
}

.search {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/globals/editCustomers.vue